import { memo, useMemo } from "react";

import { TRACK_EVENT_CATEGORY_ROUTE_HEADER } from "../constants";
import FocusSvg from "../img/FocusSvg";
import { setIsFollowingVehicle, trackEvent } from "../model/actions";
import useAppDispatch from "../utils/hooks/useAppDispatch";
import useAppSelector from "../utils/hooks/useAppSelector";

import Spinner from "./Spinner";

import "./FollowVehicleButton.scss";

interface FollowVehicleButtonProps {
  line: { color: string; text_color: string };
  trainId: number | string;
}

function FollowVehicleButton({ line, trainId }: FollowVehicleButtonProps) {
  const dispatch = useAppDispatch();
  const isFollowingVehicle = useAppSelector(
    (state) => state.isFollowingVehicle,
  );
  const isFollowingVehicleLoading = useAppSelector(
    (state) => state.isFollowingVehicleLoading,
  );
  const realtimeLayer = useAppSelector((state) => state.realtimeLayer);

  const canFollowVehicle = useMemo(() => {
    return !!realtimeLayer?.trajectories?.[trainId];
    // Testing the length make sure we test everytime a new trajectory is added.
    // eslint-disable-next-line @eslint-react/exhaustive-deps, react-hooks/exhaustive-deps
  }, [realtimeLayer?.trajectories?.length, trainId]);

  if (!canFollowVehicle) {
    return null;
  }

  return (
    <button
      className="bt-reset"
      disabled={isFollowingVehicleLoading}
      onClick={() => {
        if (!isFollowingVehicle) {
          window.scroll({ behavior: "smooth", top: 0 });
          dispatch(
            trackEvent(
              TRACK_EVENT_CATEGORY_ROUTE_HEADER,
              "followVehicle",
              String(trainId),
            ),
          );
        }
        dispatch(setIsFollowingVehicle(!isFollowingVehicle));
      }}
      style={{
        alignItems: "center",
        backgroundColor: isFollowingVehicle ? line.color : "transparent",
        borderRadius: 5,
        color: isFollowingVehicle ? line.text_color : "inherit",

        display: "flex",
        gap: 7,
        height: 30,
        justifyContent: "center",
        opacity: isFollowingVehicleLoading ? 0.5 : 1,
        padding: "0 7px",
      }}
      title="Zug folgen"
      type="button"
    >
      <div style={{ display: "flex", height: 16, width: 16 }}>
        {isFollowingVehicleLoading ? (
          <Spinner
            color={isFollowingVehicle ? line.text_color : undefined}
            size={16}
          />
        ) : (
          <FocusSvg
            fill={isFollowingVehicle ? line.text_color : "inherit"}
            height={16}
            width={16}
          />
        )}
      </div>
      <div className="route-follow-text" style={{ flex: 1 }}>
        Zug folgen
      </div>
    </button>
  );
}

export default memo(FollowVehicleButton);
